const color = {
    // Lea's Design
    blurple: '#6347ff',
    blurpleAlpha: '#f5f0ff',

    // Ant Design
    blue: '#1890ff',
    toDo: '#9E35EB',
    inProgress: '#FFCA53',
    underReview: '#FF9A21',
    completed: '#4DD87A',
};

const studentColors = [
    '#FF6F61', // Living Coral
    '#009B77', // Emerald
    '#5B5EA6', // Blue Izis
    '#45B8AC', // Turquoise
    '#88B04B', // Greenery
    '#F7CAC9', // Rose Quartz
    '#6B5B95', // Ultra Violet
    '#92A8D1', // Serenity
    '#955251', // Marsala
    '#B565A7', // Radiand Orchid
    '#DD4124', // Tangerine Tango
    '#D65076', // Honeysucle
    '#EFC050', // Mimosa
];

export default color;

export { studentColors };
